module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house6.823b6ea5.png";